import { nanoid } from 'nanoid';

var inputMixin = {
  model: {
    prop: 'value',
    event: 'input'
  },
  inject: {
    formItem: {
      default: ''
    }
  },
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: [Number, String],
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },

    /**
     * @deprecated since version 3.0.0
     */
    label: {
      type: String,
      default: '',

      validator: function validator(value) {
        return true;
      }

    },

    /**
     * @deprecated since version 3.0.0
     */
    textAfter: {
      type: String,
      default: '',

      validator: function validator(value) {
        return true;
      }

    },

    /**
     * @deprecated since version 3.0.0
     */
    textBefore: {
      type: String,
      default: '',

      validator: function validator(value) {
        return true;
      }

    },

    /**
     * @deprecated since version 3.0.0
     */
    textError: {
      type: String,
      default: '',

      validator: function validator(value) {
        return true;
      }

    },
    isValid: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    }
  },
  data: function (vm) { return ({
    hovering: false,
    focused: false,
    generatedId: vm.id,
    innerValue: vm.value
  }); },
  computed: {
    isValidDI: function isValidDI() {
      return this.formItem ? this.formItem.isValid : this.isValid;
    },

    isErrorDI: function isErrorDI() {
      if (!this.textError) {
        return this.formItem ? !!this.formItem.textError : this.isError;
      }

      return this.formItem ? !!this.formItem.textError : !!this.textError;
    },

    labelDI: function labelDI() {
      return this.formItem ? '' : this.label;
    },

    textAfterDI: function textAfterDI() {
      return this.formItem ? '' : this.textAfter;
    },

    textBeforeDI: function textBeforeDI() {
      return this.formItem ? '' : this.textBefore;
    },

    textErrorDI: function textErrorDI() {
      return this.formItem ? '' : this.textError;
    },

    beforeTextHelper: function beforeTextHelper() {
      return this.textErrorDI.length ? this.textErrorDI : this.textBeforeDI;
    },

    nativeId: function nativeId() {
      return this.formItem ? this.formItem.nativeId : this.generatedId;
    },

    isEmptyValue: function isEmptyValue() {
      return this.innerValue !== '';
    },

    isShowClear: function isShowClear() {
      if (this.clearable) {
        return this.clearable && !this.disabled && !this.readonly && !!this.innerValue && (this.focused || this.hovering);
      }

      return false;
    }

  },
  watch: {
    value: function value(value$1, oldValue) {
      if (value$1 !== oldValue) {
        this.innerValue = value$1;
      }
    }

  },

  mounted: function mounted() {
    if (!this.id) {
      this.generatedId = nanoid();
    }
  },

  updated: function updated() {
    this.updatePadding();
  },

  methods: {
    getInput: function getInput() {
      return this.$refs.input;
    },

    handleInput: function handleInput(event) {
      this.innerValue = event.target.value;
      this.$emit('input', event.target.value);
    },

    handleChange: function handleChange(event) {
      this.$emit('change', event);
    },

    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    },

    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },

    focus: function focus() {
      this.getInput().focus();
    },

    blur: function blur() {
      this.getInput().blur();
    },

    clear: function clear() {
      this.innerValue = '';
      this.$emit('clear');
      this.$emit('input', '');
      this.focus();
    },

    updatePadding: function updatePadding() {
      if (this.$refs.beforeText) {
        var el = this.$refs.beforeText;
        var height = el.offsetHeight;
        var defaultHeight = 24;

        if (height > defaultHeight && this.$refs.control) {
          this.$refs.control.style.paddingBottom = (height - defaultHeight) + "px";
        } else {
          this.$refs.control.style.paddingBottom = '';
        }
      } else {
        this.$refs.control.style.paddingBottom = '';
      }
    }

  }
};

export default inputMixin;
